import { outOfBandThemeColors } from '@/theme/colors';
import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { StyledLandingComponentContentWrapper } from './LandingStyles';

export const PaymentLandingComponentContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
}));

export const StyledPaymentSectionContentWrapper = styled(StyledLandingComponentContentWrapper)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    maxWidth: theme.spacing(116.5),
    width: 'auto',
  },
}));

export const StylePaymentIconContainer = styled(Box)(({ theme }) => ({
  background: outOfBandThemeColors.uMeds.infoA100,
  borderRadius: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  justifyItems: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: theme.spacing(142.5),
    width: 'auto',
  },
}));

export const StyledPaymentIconWrapper = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(5),
  listStyle: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  justifyItems: 'center',
  padding: `${theme.spacing(19.5)} ${theme.spacing(5)}`,
  [theme.breakpoints.up('md')]: {
    padding: `${theme.spacing(27.5)} ${theme.spacing(33)}`,
  },
}));

export const StyledPaymentOptionsIcon = styled('li')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.spacing(14),
  width: theme.spacing(20.5),
  listStyle: 'none',
  '& img': {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
}));
